import { render, staticRenderFns } from "./coursejump.vue?vue&type=template&id=5c33cea5&"
import script from "./coursejump.vue?vue&type=script&lang=js&"
export * from "./coursejump.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports